import React from "react";
import styled from "styled-components";
import updatedPgaMemberLogo from "../../../../assets/images/updatedPgaMemberLogo.png";

const PgaLogoContainer = styled.div`
  height: 45px;
  width: 44px;
`;

export default ({ src = updatedPgaMemberLogo }) => (
  <PgaLogoContainer>
    <img
      src={src}
      alt="member professional logo"
      style={{ width: "100%", height: "100%" }}
    />
  </PgaLogoContainer>
);
